module.exports = __webpack_public_path__ + "static/img/Artboard@2x.6064fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Artboard@2x.png
// module id = ALVY
// module chunks = 1